/*
 * @nevware21/ts-utils
 * https://github.com/nevware21/ts-utils
 *
 * Copyright (c) 2022 Nevware21
 * Licensed under the MIT license.
 */
import { _pureAssign, _pureRef } from "./treeshake_helpers";
// These constants are currently NOT exported directly, we may export them later associated with a frozen namespace (maybe)
// For now do NOT expect that we will export these values.
export var UNDEF_VALUE = undefined;
export var NULL_VALUE = null;
export var EMPTY = "";
export var FUNCTION = "function";
export var OBJECT = "object";
export var PROTOTYPE = "prototype";
export var __PROTO__ = "__proto__";
export var UNDEFINED = "undefined";
export var CONSTRUCTOR = "constructor";
export var SYMBOL = "Symbol";
export var POLYFILL_TAG = "_polyfill";
export var LENGTH = "length";
export var NAME = "name";
export var CALL = "call";
export var TO_STRING = "toString";
/**
 * @ignore
 */
export var ObjClass = ( /*#__PURE__*/_pureAssign(Object));
/**
 * @ignore
 */
export var ObjProto = ( /*#__PURE__*/_pureRef(ObjClass, PROTOTYPE));
/**
 * @ignore
 */
export var StrCls = ( /*#__PURE__*/_pureAssign(String));
/**
 * @ignore
 */
export var StrProto = ( /*#__PURE__*/_pureRef(StrCls, PROTOTYPE));
/**
 * @ignore
 */
export var MathCls = ( /*#__PURE__*/_pureAssign(Math));
/**
 * @ignore
 */
export var ArrCls = ( /*#__PURE__*/_pureAssign(Array));
/**
 * @ignore
 */
export var ArrProto = ( /*#__PURE__*/_pureRef(ArrCls, PROTOTYPE));
/**
 * @ignore
 *
 */
export var ArrSlice = ( /*#__PURE__*/_pureRef(ArrProto, "slice"));
//# sourceMappingURL=constants.js.map